<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="file_018"></a><a id="page_9">If you really want a hands-on experience, you can start with raw wool. You can find raw wool at local sheep farms or at your local county and state fairs. Washing the wool is easy. Fill a tub with hot water, add a little dish soap, and let the wool soak without agitating it. It is very important not to agitate the wool while it is in the hot water or it may felt. Soak the wool for about an hour, rinse, and repeat. When the rinse water is clean, lay the wool out on towels and roll to absorb the water. Or put the wool in the spin-cycle only of your washing machine. Let the wool dry completely.</a></p><a id="page_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_018.vue?3a55ddd8